import { render, staticRenderFns } from "./CorpoDialog.vue?vue&type=template&id=342920e8"
import script from "./CorpoDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./CorpoDialog.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports